import { useColorMode } from '@chakra-ui/react';
import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './app/pages/Home';

function ForceDarkMode() {
  const { setColorMode } = useColorMode();
  useEffect(() => {
    setColorMode("dark");
  }, [setColorMode]);
  return null;
}
// commit test
function App() {
  return (
    <>
      <ForceDarkMode />
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
